import { isInteger, parseNumber } from '../../lib/utils'

const DEFAULTS = {
  fieldGroupOrder: ["terms", "participants", "termAge", "duration", "datetime", "contact", "pricing"],
  fieldGroupMap: {
    participants: 'participantsCountStepNumber',
    termAge: 'ageConfirmationStepNumber',
    duration: 'hoursStepNumber',
    datetime: 'dateSelectionStepNumber',
    contact: 'personalDetailsStepNumber',
    pricing: 'pricingSummaryStepNumber',
  }
}

export default {
  data() {
    return {
      participantsCountStepNumber: 1,
      ageConfirmationStepNumber: 2,
      hoursStepNumber: 3,
      dateSelectionStepNumber: 4,
      personalDetailsStepNumber: 5,
      pricingSummaryStepNumber: 6,
    }
  },
  watch: {
    orderedFieldGroups: {
      handler(items) {
        if (items) {
          items
            .filter((group) => DEFAULTS.fieldGroupMap[group])
            .forEach((group, index) => {
              const stepStore = DEFAULTS.fieldGroupMap[group]
              if (stepStore) {
                this[stepStore] = index + 1
              }
            })
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    orderedFieldGroups() {
      return this.formFieldDetails?.groupOrder
        || DEFAULTS.fieldGroupOrder
    },
    disabled() {
      return this.termsAgreed !== 'yes'
    },
    disabledOtherThanParticipants() {
      return this.disabled || this.isGroupEventDetected
    },
    participantsNotSet() {
      const min = this.minParticipants || 1
      const count = parseNumber(this.participants)
      return !isInteger(count, 1) || count < min ||
        count > this.maxParticipants
    },
    playersNotSet() {
      return this.disabledOtherThanParticipants ||
        this.participantsNotSet
    },
    isAgeTermsAgreed() {
      return !this.playersNotSet && this.ageTermsAgreed === 'yes'
    },
    isDurationNotSet() {
      return this.playersNotSet ||
        !parseNumber(this.duration)
    },
    dateNotSelected() {
      return this.isDurationNotSet || !this.selectedDate
    },
    showTimeslotInputs() {
      return !this.dateNotSelected
    },
    showTimeslotInfo() {
      return this.showTimeslotInputs && !_.isEmpty(this.retrievedTimeslots)
    },
    noSlotSelected() {
      return !_.size(this.selectedSlots)
    },
    showMiniCart() {
      return this.showTimeslotInfo && !this.noSlotSelected && !this.isAnyProcessing()
    },
    cartNotReady() {
      return this.isPersonalDetailsInvalid || !this.showMiniCart
    },
    disabledPersonalDetails() {
      return this.isDurationNotSet
    }
  }
}
